import { render, staticRenderFns } from "./ListSeguroincendioPage.vue?vue&type=template&id=1782d540&"
import script from "./ListSeguroincendioPage.vue?vue&type=script&lang=js&"
export * from "./ListSeguroincendioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports